import * as React from 'react';
import { useAnimate } from 'framer-motion';

import { useUiStore } from 'stores';

export const useAnimation = () => {
  const uiStore = useUiStore();
  const [ref, animate] = useAnimate();

  React.useEffect(() => {
    const changeState = async () => {
      if (uiStore.menuState.opened) {
        await animate(
          ref.current,
          {
            x: 0
          },
          {
            stiffness: 0,
            damping: 0
          }
        );
      } else {
        animate(
          ref.current,
          {
            x: '-100%'
          },
          {
            stiffness: 0,
            damping: 0
          }
        );
      }
    };
    changeState();
  }, [uiStore.menuState.opened]);

  return {
    ref
  };
};
